// extracted by mini-css-extract-plugin
export default {"root":"app-react-sidebar-Sidebar-module__root","nav":"app-react-sidebar-Sidebar-module__nav","navListContainer":"app-react-sidebar-Sidebar-module__nav-list-container"};